<template>
  <CardItem
      :show-content="isCurrent"
      :options="options"
      v-on="$listeners"
  >
    <div class="flex flex-col flex-grow items-center justify-center">
      <TextQuestion class="text-center">
        <TextCollapsed
            :title="question.text"
            :max-length="question.imageSrc ? 100 : 300"
        />
      </TextQuestion>
    </div>
    <template #button>
      <div class="flex justify-center">
        <div>
          <a-rate
              v-if="ratingType === 'stars'"
              v-model="value"
              :allowClear="false"
              class="justify-between"
              style="display: flex;"
              @change="onNext"
          />
          <SmileIcons
              v-else
              v-model="value"
              :scale="scale"
              :type="ratingType"
              @change="onNext"
          />
          <div class="mt-2 space-x-2 xs:space-x-4">
            <TextHelp v-if="showMinLabel" class="float-left">{{ minLabel }}</TextHelp>
            <TextHelp v-if="showMaxLabel" class="float-right">{{ maxLabel }}</TextHelp>
          </div>
        </div>
      </div>
    </template>
  </CardItem>
</template>

<script>
import {Rate} from "ant-design-vue"
import SmileIcons from "../SmileIcons";
import questionMixin from "@/mixins/question";
import {mapGetters} from "vuex";
import themeMixin from "../../mixins/theme.mixin";
import CardItem from "../CardItem";
import TextCollapsed from "../TextCollapsed";
import TextQuestion from "../TextQuestion";
import TextHelp from "../TextHelp";
import {questionEventListenerMixin} from "../../mixins/question";

export default {
  name: "QuestionRating",
  props: {
    isCurrent: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
  },
  components: {'a-rate': Rate, SmileIcons, CardItem, TextCollapsed, TextQuestion, TextHelp},
  mixins: [questionMixin, questionEventListenerMixin, themeMixin],
  data() {
    return {
      value: null,
    }
  },
  computed: {
    ...mapGetters(["survey"]),
    ratingType: function () {
      return this.question.subtype;
    },
    scale: function () {
      switch (this.question.options.ratingScale) {
        case 2:
          return [1, 5];
        case 3:
          return [1, 3, 5];
        default:
          return [1, 2, 3, 4, 5];
      }
    },
    minLabel: function () {
      if (this.ratingType === 'stars') {
        return this.question.translations.minLabel.value || this.survey.translations.questions.likertStars.minLabel.value || this.survey.translations.questions.likertStars.minLabel.defaultValue;
      }
      return this.question.translations.minLabel.value || this.survey.translations.questions.likertSmiles.minLabel.value || this.survey.translations.questions.likertSmiles.minLabel.defaultValue;
    },
    maxLabel: function () {
      if (this.ratingType === 'stars') {
        return this.question.translations.maxLabel.value || this.survey.translations.questions.likertStars.maxLabel.value || this.survey.translations.questions.likertStars.maxLabel.defaultValue;
      }
      return this.question.translations.maxLabel.value || this.survey.translations.questions.likertSmiles.maxLabel.value || this.survey.translations.questions.likertSmiles.maxLabel.defaultValue;
    },
    showMinLabel: function () {
      return this.question.translations.minLabel.active
    },
    showMaxLabel: function () {
      return this.question.translations.maxLabel.active
    },
  },
  methods: {
    onNext() {
      this.onAnswer(this.value);
    },
    onKeyDown(e) {
      if (!this.isCurrent) return;

      let value = parseInt(e.code.substring(e.code.length - 1));

      if (value > 0 && value <= this.scale.length) {
        this.value = this.scale[value - 1];
        this.onNext();
      }
    }
  }
}
</script>

<style scoped>

</style>
